export const ORDER_CREATE_REQUEST='ORDER_CREATE_REQUEST'
export const ORDER_CREATE_SUCCESS='ORDER_CREATE_SUCCESS'
export const ORDER_CREATE_FAIL='ORDER_CREATE_FAIL'
export const ORDER_CREATE_RESET='ORDER_CREATE_RESET'

export const ORDER_PAY_REQUEST='ORDER_PAY_REQUEST'
export const ORDER_PAY_SUCCESS='ORDER_PAY_SUCCESS'
export const ORDER_PAY_FAIL='ORDER_PAY_FAIL'
export const ORDER_PAY_RESET='ORDER_PAY_RESET'

export const ORDER_DETAIL_REQUEST = 'ORDER_DETAIL_REQUEST' 
export const ORDER_DETAIL_SUCCESS = 'ORDER_DETAIL_SUCCESS' 
export const ORDER_DETAIL_FAIL = 'ORDER_DETAIL_FAIL' 

export const ORDER_MINE_LIST_REQUEST = 'ORDER_MINE_LIST_REQUEST' 
export const ORDER_MINE_LIST_SUCCESS = 'ORDER_MINE_LIST_SUCCESS' 
export const ORDER_MINE_LIST_FAIL = 'ORDER_MINE_LIST_FAIL' 